import React, { useCallback, useEffect, useState } from "react";
import { Close as CloseIcon, Edit as EditIcon } from "@material-ui/icons";
import { IconButton, makeStyles, TextField } from "@material-ui/core";
import { debounce } from "lodash";
import { useScheduleEvents } from "../../../../app/contexts/schedule.events.context";
import CustomTooltip from "../../../../app/components/tooltip/custom.tooltip";
import clsx from "clsx";

export default function EditNotesInput({
  editState,
  setEditState,
  d,
  readOnly,
}) {
  const { setUpdatedSamplingStrategyValues } = useScheduleEvents();
  const [notes, setNotes] = useState(d.notes || '');
  const classes = useIconButtonStyles();

  useEffect(() => {
    setNotes(d.notes || '');
  }, [d.notes]);

  const updateNote = (value) =>
    setUpdatedSamplingStrategyValues((prev) => {
      const newSet = { ...prev };
      newSet[`${d.scheduleOfEventsId}-${d.tableSort}-${d.rowSort}`] = {
        notes: value,
      };
      return newSet;
    });

  // add a debounce to the note state and call updateNote with that
  const debouncedUpdateNote = useCallback(debounce(updateNote, 500), []);

  return (
    <>
      {!editState[d.rowLabel] ? (
        <CustomTooltip title={notes || ""}>
          <p style={{ paddingRight: "30px", wordBreak: "break-word" }}>
            {notes}
          </p>
        </CustomTooltip>
      ) : (
        <CustomTooltip title={notes || ''}>
          <div style={{ width: "100%" }}>
            <TextField
              inputProps={{
                maxLength: 500,
              }}
              variant="outlined"
              label="Notes"
              multiline
              rows={4}
              fullWidth
              value={notes}
              onChange={(e) => {
                const value = e.target.value;
                setNotes(value);
                debouncedUpdateNote(value);
              }}
            />
          </div>
        </CustomTooltip>
      )}
      {!readOnly && (<IconButton
        variant="text"
        color="primary"
        disableRipple
        onClick={() =>
          setEditState((prev) => ({
            ...prev,
            [d.rowLabel]: !editState[d.rowLabel],
          }))
        }
        className={clsx(
          classes.iconButton,
          !editState[d.rowLabel] ? classes.top5 : classes.top10,
        )}
      >
        {!editState[d.rowLabel] ? (
          <EditIcon style={{ width: "1rem", height: "1rem" }} />
        ) : (
          <CloseIcon style={{ width: "1rem", height: "1rem" }} />
        )}
      </IconButton>)}
    </>
  );
}

const useIconButtonStyles = makeStyles(() => ({
  iconButton: {
    position: "absolute",
    right: "10px",
    padding: "4px",

    "&:hover": {
      backgroundColor: "var(--teal-100)",
    },

    "&.active": {
      backgroundColor: "var(--teal-300)",
    },
  },
  top5: {
    top: "5px",
  },
  top10: {
    top: "10px",
  },
  icon: {
    width: "1rem",
    height: "1rem",
  },
}));
